import { useEffect, useMemo, useState } from 'react';
import api from '../services/api';
import mt5ServersBundled from '../data/mt5-servers.json';

// Broker/server list for any MT5 credential form (registration, connecting an
// additional account). Shared so both pickers show the same brokers.
//
// MERGES the backend harvester's live list with the bundled JSON rather than
// replacing it — the harvester may return only a handful (e.g. just the
// journal-scraped in-use brokers) and the picker must never show fewer than
// the curated fallback.
export default function useMt5Servers() {
  const [servers, setServers] = useState(mt5ServersBundled);

  useEffect(() => {
    let alive = true;
    api.get('/brokers')
      .then((res) => {
        const list = res.data?.servers;
        if (!alive || !Array.isArray(list) || !list.length) return;
        const byServer = new Map();
        for (const s of mt5ServersBundled) byServer.set(s.server, s);
        for (const s of list) byServer.set(s.server, s); // harvested wins on conflict
        setServers([...byServer.values()]);
      })
      .catch(() => { /* keep bundled fallback */ });
    return () => { alive = false; };
  }, []);

  const brokers = useMemo(
    () => Array.from(new Set(servers.map(s => s.broker))).sort(),
    [servers],
  );

  return { servers, brokers };
}
